import i18n from "../../../../../constants/i18n";
import { AUTITOR_PROMO_CODE_SEARCH_HEADERS } from "../../../../../constants/table-custom-headers/Auditor";
import getPromoCodeStore from "../../../../../stores/auditor-store/promocode-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Table from "../../../../../core/et3-table";

const PromoCodeUsageData = withLiteObserverAndTheme(() => {
  const { promoCodeUsageHistoryArray } =
    getPromoCodeStore().getPromoCodesArrays();

  return (
    <Et3Table
      columns={AUTITOR_PROMO_CODE_SEARCH_HEADERS}
      rows={promoCodeUsageHistoryArray}
      title={i18n.get("PROMO_CODES")}
      shouldBeFlagged={false}
      titleKey={"PROMO_CODES_USAGE"}
    />
  );
});
export default PromoCodeUsageData;
